

import Component from "vue-class-component";
import {Prop} from "vue-property-decorator";
import {IShortChannel} from "@/model/shortInterfaces";
import ChipMixin from "@/components/shared/chips/ChipMixin";

@Component({
  mixins: [ChipMixin]
})
export default class ChannelChip extends ChipMixin {

  @Prop()
  protected item!: IShortChannel;
  @Prop()
  protected name!: string;
  @Prop()
  protected slug!: string;
  @Prop({default: true})
  protected withSlug!: boolean;

  protected get caption(): string|null {
    return this.withSlug
      ? null
      : this.slug || (this.item||{}).slug || null
    ;
  }

}

